import axios from "axios";

const clienteAxiosTradeIn = axios.create({
  baseURL: "https://tda.vwmapps.com.mx",
});

export const sendTradeIn = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosTradeIn({
        method: "post",
        url: "/api-prd/recibetradein",
        headers: {
          "Content-Type": "application/json",
          authentication_id:
            "Bearer " + process.env.REACT_APP_TOMA_DE_AUTO_SERVICIOS_DIGITALES_TOKEN,
        },
        data: payload,
      });
      resolve(respuesta);
    } catch (error) {
      console.error("Error en petición de trade-in:", error);
      reject("Error en petición de trade-in");
    }
  });
};
